import { render, staticRenderFns } from "./ComponentLPInfo.vue?vue&type=template&id=1b389729"
import script from "./ComponentLPInfo.vue?vue&type=script&lang=js"
export * from "./ComponentLPInfo.vue?vue&type=script&lang=js"
import style0 from "./ComponentLPInfo.vue?vue&type=style&index=0&id=1b389729&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports